import { fetchData, encodeQueryData } from '../Utils/fetchData';

const getArticles = (params) => {
  const url = `amica/api/blog/search?${encodeQueryData(params)}`;
  return fetchData(url, { data: params });
};

export default { getArticles };
